import * as React from 'react';
import { Flat } from './Flat';
import * as styles from './similarFlatsList.css';
import { UIHeading2, UIText2 } from '@cian/ui-kit';
import { useFlats } from './useFlats';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SimilarFlatsList = function SimilarFlatsList(_ref) {
  var offerId = _ref.offerId;
  var _useFlats = useFlats({
      offerId: offerId
    }),
    isError = _useFlats.isError,
    isLoading = _useFlats.isLoading,
    flats = _useFlats.flats,
    title = _useFlats.title;
  if (!flats || isError || isLoading) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: styles['list'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles['header'],
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['title'],
        children: /*#__PURE__*/_jsx(UIHeading2, {
          children: "\u0422\u0430\u043A\u0438\u0435 \u0436\u0435 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u043D\u0430 \u0434\u0440\u0443\u0433\u0438\u0445 \u044D\u0442\u0430\u0436\u0430\u0445"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles['description'],
        children: /*#__PURE__*/_jsx(UIText2, {
          color: "current_color",
          children: title
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles['flats'],
      children: flats.map(function (flat) {
        return /*#__PURE__*/_jsx(Flat, {
          floor: flat.floorNumber,
          url: flat.offerUrl,
          booked: flat.booked,
          hasDecoration: flat.hasDecoration,
          img: flat.previewUrl,
          price: flat.price,
          title: flat.title
        }, flat.offerUrl);
      })
    })]
  });
};